/**
 * Clear Synced Data UseCase
 * 
 * Clears all synced data from local storage on logout.
 * 
 * Matches Flutter pattern where synced data is cleared on logout for privacy.
 */

import { SecureStorageWebCrypto } from '@/data/storage/local/secureStorageWebCrypto';
import { appLogger } from '@/domain/services/analytics/appLogger';

export class ClearSecureStorageUseCase {
  private storage: SecureStorageWebCrypto;

  constructor(storage?: SecureStorageWebCrypto) {
    this.storage = storage || SecureStorageWebCrypto.getInstance();
  }

  /**
   * Clear all synced data from local storage
   * 
   * Note: This clears ALL data in SecureStorageWebCrypto including:
   * - Sync entity status
   * - User likes, saved content, etc.
   * - Wallet data
   * - Settings
   * - All encrypted data
   */
  async execute(): Promise<void> {
    try {
      console.log('[ClearSyncedDataUseCase] Clearing all synced data');

      // Clear all encrypted storage
      // The clear() method works even if storage is not initialized - it will
      // temporarily open the DB, clear it, and close it.
      await this.storage.clear();

      // Close the storage connection to release resources
      this.storage.close();

      console.log('[ClearSyncedDataUseCase] Synced data cleared successfully');
    } catch (error) {
      appLogger.error('Failed to clear synced data', 'ClearSecureStorageUseCase.execute', { error: error as Error });
      // Don't throw - this shouldn't block logout
      // Even if clearing fails, we want logout to proceed
    }
  }
}
